'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Button = require('../../primitives/Button/Button.js');
var Hero = require('../../primitives/Hero/Hero.js');
require('../../primitives/HeroSrcSet/HeroSrcSet.js');
require('../../primitives/Icon/Icon.js');
require('../../primitives/Link/Link.js');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var ErrorPage = function ErrorPage(props) {
  var homePage = props.homePage,
    variant = props.variant;
  var btnText, errorText, image, title;
  switch (variant) {
    case 'notFound':
      btnText = 'Back To Home Page';
      errorText = "We’re sorry, this web page is missing. Try using our search, or <a href='mailto:cms_help@lanl.gov'>email us</a>.";
      image = 'https://cdn.lanl.gov/07be69a4-bf21-443f-bca0-0c57541856c9.jpg';
      title = 'Page Not Found';
      break;
    case 'accessDenied':
      btnText = 'Back To Home Page';
      errorText = "We’re sorry, but you don’t have access to this page. If you believe you should have access, or need further assistance, please reach out to our <a href='mailto:cms_help@lanl.gov'>support team</a>.";
      image = 'https://cdn.lanl.gov/18681e0b-8e9e-4030-bac5-6f8f93bd4ce7.jpg';
      title = 'Oops! Access Denied';
      break;
    case 'serviceUnavailable':
      btnText = 'Back To Home Page';
      errorText = 'This service is unavailable.';
      image = 'https://cdn.lanl.gov/1694f199-2426-457e-a542-eeb479e92e01.jpg';
      title = 'Service Unavailable';
      break;
  }
  var errorPageClasses = index.default('error-page');
  var titleClasses = index.default('error-title');
  var errorTextClasses = index.default('error-text');
  var btnClasses = index.default('error-btn');
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: errorPageClasses
  }, /*#__PURE__*/React__default.default.createElement(Hero.Hero, {
    img: image
  }, /*#__PURE__*/React__default.default.createElement("h1", {
    className: titleClasses
  }, title), errorText && /*#__PURE__*/React__default.default.createElement("p", {
    className: errorTextClasses,
    dangerouslySetInnerHTML: {
      __html: errorText
    }
  }), btnText && homePage && /*#__PURE__*/React__default.default.createElement(Button.Button, {
    arrow: false,
    className: btnClasses,
    color: 'secondary',
    href: homePage,
    target: '_self'
  }, btnText)));
};
ErrorPage.defaultProps = {
  homePage: 'https://lanl.gov',
  variant: 'notFound'
};
ErrorPage.propTypes = {
  homePage: PropTypes__default.default.string,
  variant: PropTypes__default.default.oneOf(['notFound', 'accessDenied', 'serviceUnavailable'])
};

exports.ErrorPage = ErrorPage;
exports.default = ErrorPage;
//# sourceMappingURL=ErrorPage.js.map
